export default "__VITE_ASSET__bnbxT2MR__"